import { createContext, useContext } from "react";
import type { Amc } from "features/Amc/types/amc.types";

export interface AmcContractOverviewContextType {
  contract: Amc | null;
  refetch: () => Promise<void>;
}

const AmcContractOverviewContext =
  createContext<AmcContractOverviewContextType | null>(null);

export function useAmcContractOverview() {
  const ctx = useContext(AmcContractOverviewContext);
  if (!ctx) {
    throw new Error("useAmcContractOverview must be used within provider");
  }
  return ctx;
}

export default AmcContractOverviewContext;
